import {useEffect, React} from 'react'
import { useNavigate } from 'react-router-dom';

export const VerifyEmailPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate('/');
    }, 3000);
  }, [navigate]);

  return (
    <div className="content-container">
      <h1>Thanks for signing up!</h1>
      <p>
        We just sent you an email to verify your email address. Please check your email and click on the link to verify your email.
      </p>
    </div>
  )
}